/** Các hàm định dạng hiển thị dùng chung. */

const MONTHS = [
    'Tháng 1', 'Tháng 2', 'Tháng 3', 'Tháng 4', 'Tháng 5', 'Tháng 6',
    'Tháng 7', 'Tháng 8', 'Tháng 9', 'Tháng 10', 'Tháng 11', 'Tháng 12',
];

/** '2025-06' -> 'Tháng 6, 2025' */
export const formatMonth = (value) => {
    if (!value) return '';
    const [year, month] = value.split('-');
    const index = Number(month) - 1;
    if (!year || index < 0 || index > 11) return value;
    return `${MONTHS[index]}, ${year}`;
};

/** Rút gọn URL để hiển thị: 'https://github.com/a/b' -> 'github.com/a/b' */
export const prettyUrl = (url) => {
    if (!url) return '';
    return url.replace(/^https?:\/\//, '').replace(/\/$/, '');
};

/** Lấy chữ cái đầu làm avatar khi ứng dụng chưa có ảnh. */
export const initials = (text = '') =>
    text
        .split(/\s+/)
        .filter(Boolean)
        .slice(0, 2)
        .map((word) => word[0])
        .join('')
        .toUpperCase();
